import React, { useEffect, useState } from "react";

import { getCookie } from "../../utils/utility-functions";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTE_CONSTANT } from "../../routing/route-constants";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Tabs from "../../components/tab";
import AdminUserDetails from "../admin-user-details";
import AdminUserDocuments from "../admin-user-documents/";
import AdminReactivateUser from "../admin-reactivate-user";
import UpdateUserEmai from "../emailid-update-user";

function AdminSearch() {
  const token = getCookie("jwtToken");
  const navigate = useNavigate();
  const location = useLocation();

  // Extract query parameter for step
  const searchParams = new URLSearchParams(location.search);
  const stepParam = searchParams.get("step") || "tab1";
  const [activeStep, setActiveStep] = useState(stepParam);

  useEffect(() => {
    if (!token) {
      navigate(ROUTE_CONSTANT.ADMIN_LOGIN);
    }
  }, [token]);

  const tabData = [
    {
      id: "tab1",
      label: "Users Details",
      content: <AdminUserDetails />,
      onClick: () => handleTabChange("tab1"),
    },
    {
      id: "tab2",
      label: "Recent Document",
      content: <AdminUserDocuments />,
      onClick: () => handleTabChange("tab2"),
    },
    {
      id: "tab3",
      label: "User Operations",
      content: <AdminReactivateUser />,
      onClick: () => handleTabChange("tab3"),
    },
    {
      id: "tab4",
      label: "Update User Email",
      content: <UpdateUserEmai/>,
      onClick: () =>  handleTabChange("tab4"),
    },
   
  ];
  const handleTabChange = (tabId) => {
    setActiveStep(tabId);
    searchParams.set("step", tabId);
    navigate(`?${searchParams.toString()}`, { replace: true });
  };
  return (
    <>
      {" "}
      <Header />
      <div className="w-full flex justify-center items-center">
        <div className="m-10 w-full flex flex-col gap-4">
          <Tabs
            tabs={tabData}
            initialTab={activeStep}
            onTabClick={handleTabChange}
          />
        </div>
      </div>{" "}
      <Footer className="fixed" />
    </>
  );
}

export default AdminSearch;
